var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenerationAsset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3551 20.2035L9.4423 9.6153H20.4003C20.7252 9.6153 20.9886 9.87866 20.9886 10.2035V20.2035H21.8682C22.0321 20.2035 22.165 20.3339 22.165 20.5004V21.0831C22.165 21.2471 22.032 21.38 21.8707 21.38H2.45937C2.29681 21.38 2.16504 21.2496 2.16504 21.0831V20.5004C2.16504 20.3365 2.29902 20.2035 2.45972 20.2035H3.6748L4.56729 7.26236H8.35383L9.46945 20.2035H10.3551ZM19.2239 18.1475C19.2239 17.9835 19.0911 17.8506 18.9288 17.8506H11.8719C11.7089 17.8506 11.5768 17.981 11.5768 18.1475V18.7302C11.5768 18.8942 11.7095 19.0271 11.8719 19.0271H18.9288C19.0917 19.0271 19.2239 18.8967 19.2239 18.7302V18.1475ZM19.2239 15.2063C19.2239 15.0423 19.0911 14.9094 18.9288 14.9094H11.8719C11.7089 14.9094 11.5768 15.0398 11.5768 15.2063V15.789C11.5768 15.953 11.7095 16.0859 11.8719 16.0859H18.9288C19.0917 16.0859 19.2239 15.9555 19.2239 15.789V15.2063ZM19.2239 12.2651C19.2239 12.1012 19.0911 11.9682 18.9288 11.9682H11.8719C11.7089 11.9682 11.5768 12.0986 11.5768 12.2651V12.8478C11.5768 13.0118 11.7095 13.1447 11.8719 13.1447H18.9288C19.0917 13.1447 19.2239 13.0143 19.2239 12.8478V12.2651ZM4.81349 3.69248C4.83476 3.38404 5.09117 3.14471 5.40033 3.14471H7.45916C7.76445 3.14471 8.019 3.37827 8.04522 3.68243L8.27777 6.38001H4.62814L4.81349 3.69248Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerationAsset);
export default __webpack_public_path__ + "static/media/generation-asset.8f72ddf43cc9e8281578f42a7432fcc9.svg";
export { ForwardRef as ReactComponent };